import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CommonServices } from '../services/commonServices';
const commonServices = new CommonServices();

import { Loadingfuction } from '../store/reducers/loading.reducer';
import Image from '../widget/w-image';
import TextInput from '../widget/w-textInput';
import ButtonComp from '../widget/w-button';
import TextMsg from '../widget/common/textMessage';
import heroIcon from '../widget/images/bg-img.png';

interface LoginProps {}
const LoginPage: React.FC<LoginProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [emailId, setemailId] = useState('');
  const [emailIdError, setemailIdError] = useState('');
  const inputemailIdRef = useRef(null);
  const [errorText, setErrorText] = useState('');

  const [loading, setLoading] = useState(false);

  const handleemailIdValue = (event) => {
    setemailIdError('');
    setErrorText('');
    event = event.replace(/\s+/g, '');
    setemailId(event.toLowerCase());
    if (event.length > 256) {
      setTimeout(() => {
        setemailIdError('.');
        inputemailIdRef.current.focus();
      }, 50);
    }
  };

  const handleVerifyEmail = () => {
    if (emailId.trim() === '') {
      setemailIdError('Email ID is required');
      inputemailIdRef.current.focus();
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailId)) {
      setemailIdError('Please enter a valid email address');
      inputemailIdRef.current.focus();
      return;
    }
    setemailIdError('');
    dispatch(Loadingfuction({ loading: true }));
    const data = {
      email_id: emailId,
    };
    commonServices
      .validateCompanyAPI(data)
      .then((res) => {
        console.log(res.data);
        if (res.data.company_registered) {
          const targetUrl = res.data.redirect_url;
          window.open(
            `${targetUrl}?email=${emailId}&status=${res.data.user_registered}`,
            '_self',
          );
        } else {
          window.open(
            'https://arivonix.ai/free-trial?email=' + emailId,
            '_self',
          );
        }
      })
      .catch((err) => {
        setemailIdError(
          'An error occurred while verifying the email. Please try again.',
        );
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(Loadingfuction({ loading: false }));
        }, 2000);
      });
  };

  return (
    <>
      <section className='d-flex align-items-center justify-content-center h-100 w-100'>
        <div className='container'>
          <div className='row g-0 align-items-center py-2'>
            <div className='col-sm-12 col-lg-12 px-1 px-lg-12 d-flex justify-content-center'>
              <>
                {loading ? (
                  <div>
                    <Image
                      imageClass='loader_css'
                      src='/asset/Loader.gif'
                      alt='Loading'
                      ariaLabel='Loading'
                    ></Image>
                    <div
                      id='loading-description'
                      className='content-hide text_subheding_bold'
                    >
                      Loading
                    </div>
                  </div>
                ) : null}
                <div className='bg-d-s px-3 px-lg-4 py-1 w-50 login-box'>
                  <div className='w-100 mb-3 d-flex justify-content-center flex-column align-items-center'>
                    <div className='mb-5 d-flex justify-content-center w-50'>
                      <Image
                        imageClass='w-100 d-flex justify-content-center'
                        src='/asset/logo_icon.svg'
                        alt='Arivonix_Logo'
                        ariaLabel='Arivonix Logo'
                        width={150}
                      ></Image>
                    </div>
                    
                  </div>
                  <div
                      className='t-d-75 mb-4 w-100'
                      id='sign-text'
                    >
                      <h2 className='text_subheding_bold'>Sign in</h2>                      
                    </div>
                  <TextInput
                    className={
                      'rounded-1 fw-medium w-100 py-2 px-2 ' +
                      (!emailIdError ? 'border-grey-1' : 'error-border')
                    }
                    type='text'
                    value={emailId}
                    onChange={(event) => {
                      handleemailIdValue(event);
                    }}
                    handleAction={() => {
                      handleVerifyEmail();
                    }}
                    tabIndex={0}
                    placeholder={TextMsg.registeremailIdplaceholder}
                    inputref={inputemailIdRef}
                    texterror={emailIdError}
                    maxLength={256}
                    inputLabel={TextMsg.registeremailIdLabel}
                    textInputLabel={TextMsg.registeremailIdLabel}
                  />
                  <div className='d-flex align-items-center mt-2'>
                    <div className='me-auto'>                      
                          {/* <div className='mt-2'> Don't have an account? <span className='link_tag_button' onClick={()=>{navigate('/signup')}}>Sign up</span> </div> */}
                    </div>
                    <ButtonComp
                      buttonClass='btn px-4 py-2 text_paragraph_bold text-center mt-4 mb-4 rounded-1 ms-auto'
                      ariaLabel={'Next'}
                      label={'Next'}
                      handleButtonClick={() => {
                        handleVerifyEmail();
                      }}
                      tabIndex={0}
                    />
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default LoginPage;
